
import { defineComponent } from 'vue'
import { Params } from '@/data/types'
import Loading from '@/components/Results/Loading.vue'
import User from '@/components/Results/User.vue'
import Repos from '@/components/Results/Repos.vue'
import { RouteLocationNormalizedLoaded } from 'vue-router'

export default defineComponent({
  components: {
    Loading,
    User,
    Repos,
  },
  data(this: { $route: RouteLocationNormalizedLoaded }) {
    return {
      params: {
        username: this.$route.query.username,
        organizations: this.$route.query.orgs,
        repositories: this.$route.query.repos,
        chart: this.$route.query.chart,
      } as Params,
    }
  },
})
